



import { gql } from 'graphql-tag';
import { defineAsyncComponent, defineComponent } from '@nuxtjs/composition-api';

// eslint-disable-next-line import/order
import { contentableBlockColorFragment } from '@/composables/block-color';

export default defineComponent({
  components: {
    // Add data to original page component
    Page: defineAsyncComponent(() => import('@/pages/standard.vue')),
  },
  graphqlData: gql`
    fragment StandardContentData on StandardContent {
      id
      title
      lead
      blocks {
        __typename @inject
      }
      ...ContentableBlockColor
    }

    ${contentableBlockColorFragment}
  `,
});
